import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Partner } from "../components/Partner";
import AOS from "aos";
import "aos/dist/aos.css";

export const TermsConditions = () => {

useEffect(() => {
    AOS.init({
        duration: 1500,
        once: true,
        disable: function () {
            return window.innerWidth < 992;
        },
    });
}, []);
   
return(
<div className="page-content servicepage">
    <section className="wi_full py_3 inner_banner" style={{backgroundImage: "url('./images/terms-banner.jpg')",backgroundSize: "cover",
        backgroundPosition: "center", backgroundRepeat: "no-repeat",}}>
        <div className="container" data-aos="fade-in">
            <h1>Terms &<br /> Conditions</h1>
        </div>
    </section>
    <section className="booking_sec wi_full py_3">
        <div className="container">
            <div className="sec_title text-center mb-5">
                <h2>Terms of <span>Use</span></h2>
                <p>Legal Information & Notices</p> 
            </div>
            <div className="row accordion_wrapper" data-aos="fade-up">
                <div className="col-lg-6">
                    <div className="accordion" id="accordionLeft">
                        <div className="accordion-item">
                            <h2 className="accordion-header" id="leftOne">
                                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne">Ownership of Site; Agreement to Terms of Use</button>
                            </h2>
                            <div id="collapseOne" className="accordion-collapse collapse" aria-labelledby="leftOne" data-bs-parent="#accordionLeft">
                                <div className="accordion-body"> These plans can provide a range of benefits</div>
                            </div>
                        </div>
                        <div className="accordion-item">
                            <h2 className="accordion-header" id="leftTwo">
                                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo">Content</button>
                            </h2>
                            <div id="collapseTwo" className="accordion-collapse collapse" aria-labelledby="leftTwo" data-bs-parent="#accordionLeft">
                                <div className="accordion-body"> These plans can provide a range of benefits</div>
                            </div>
                        </div>
                        <div className="accordion-item">
                            <h2 className="accordion-header" id="leftThree">
                                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree">Your Use of the Site</button>
                            </h2>
                            <div id="collapseThree" className="accordion-collapse collapse" aria-labelledby="leftThree" data-bs-parent="#accordionLeft">
                                <div className="accordion-body"> These plans can provide a range of benefits</div>
                            </div>
                        </div>
                        <div className="accordion-item">
                            <h2 className="accordion-header" id="leftFour">
                                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFour">Purchases; Other Terms and Conditions</button>
                            </h2>
                            <div id="collapseFour" className="accordion-collapse collapse" aria-labelledby="leftFour" data-bs-parent="#accordionLeft">
                                <div className="accordion-body"> These plans can provide a range of benefits</div>
                            </div>
                        </div>
                        <div className="accordion-item">
                            <h2 className="accordion-header" id="leftFive">
                                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFive">Accounts, Passwords and Security</button>
                            </h2>
                            <div id="collapseFive" className="accordion-collapse collapse" aria-labelledby="leftFive" data-bs-parent="#accordionLeft">
                                <div className="accordion-body"> These plans can provide a range of benefits</div>
                            </div>
                        </div>
                        <div className="accordion-item">
                            <h2 className="accordion-header" id="leftSix">
                                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseSix">Privacy</button>
                            </h2>
                            <div id="collapseSix" className="accordion-collapse collapse" aria-labelledby="leftSix" data-bs-parent="#accordionLeft">
                                <div className="accordion-body"> These plans can provide a range of benefits</div>
                            </div>
                        </div>
                        <div className="accordion-item">
                            <h2 className="accordion-header" id="leftSeven">
                                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseSeven">Links to Other Sites and to Sewa Insurance Agency </button>
                            </h2>
                            <div id="collapseSeven" className="accordion-collapse collapse" aria-labelledby="leftSeven" data-bs-parent="#accordionLeft">
                                <div className="accordion-body"> These plans can provide a range of benefits</div>
                            </div>
                        </div>
                     </div>
                </div>
                <div className="col-lg-6">
                    <div className="accordion" id="accordionRight">
                        <div className="accordion-item">
                            <h2 className="accordion-header" id="rightOne">
                                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse_right_One">Limitation of Liability</button>
                            </h2>
                            <div id="collapse_right_One" className="accordion-collapse collapse" aria-labelledby="rightOne" data-bs-parent="#accordionRight">
                                <div className="accordion-body"> These plans can provide a range of benefits</div>
                            </div>
                        </div>
                        <div className="accordion-item">
                            <h2 className="accordion-header" id="rightTwo">
                                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse_right_Two">Indemnity</button>
                            </h2>
                            <div id="collapse_right_Two" className="accordion-collapse collapse" aria-labelledby="rightTwo" data-bs-parent="#accordionRight">
                                <div className="accordion-body"> These plans can provide a range of benefits</div>
                            </div>
                        </div>
                        <div className="accordion-item">
                            <h2 className="accordion-header" id="rightThree">
                                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse_right_Three">Governing Law; Dispute Resolution</button>
                            </h2>
                            <div id="collapse_right_Three" className="accordion-collapse collapse" aria-labelledby="rightThree" data-bs-parent="#accordionRight">
                                <div className="accordion-body"> These plans can provide a range of benefits</div>
                            </div>
                        </div>
                        <div className="accordion-item">
                            <h2 className="accordion-header" id="rightFour">
                                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse_right_Four">Void Where Prohibited</button>
                            </h2>
                            <div id="collapse_right_Four" className="accordion-collapse collapse" aria-labelledby="rightFour" data-bs-parent="#accordionRight">
                                <div className="accordion-body"> These plans can provide a range of benefits</div>
                            </div>
                        </div>
                        <div className="accordion-item">
                            <h2 className="accordion-header" id="rightFive">
                                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse_right_Five">Miscellaneous</button>
                            </h2>
                            <div id="collapse_right_Five" className="accordion-collapse collapse" aria-labelledby="rightFive" data-bs-parent="#accordionRight">
                                <div className="accordion-body"> These plans can provide a range of benefits</div>
                            </div>
                        </div>
                        <div className="accordion-item">
                            <h2 className="accordion-header" id="rightSix">
                                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse_right_Six">Indemnity</button>
                            </h2>
                            <div id="collapse_right_Six" className="accordion-collapse collapse" aria-labelledby="rightSix" data-bs-parent="#accordionRight">
                                <div className="accordion-body"> These plans can provide a range of benefits</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <Partner />
</div>
)
}